import "@/App.css";
import { BrowserRouter, Navigate, Outlet, Route, Routes } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider, useAuth } from "@/context/AuthContext";
import { ThemeProvider } from "@/context/ThemeContext";
import { AppShell, PlatformShell } from "@/components/layout/AppShell";
import { Spinner } from "@/components/common/Primitives";
import LoginPage from "@/pages/LoginPage";
import DashboardPage from "@/pages/DashboardPage";
import VehiclesPage from "@/pages/VehiclesPage";
import VehicleDetailPage from "@/pages/VehicleDetailPage";
import IssuesPage from "@/pages/IssuesPage";
import IssueDetailPage from "@/pages/IssueDetailPage";
import ServicesPage from "@/pages/ServicesPage";
import RemindersPage from "@/pages/RemindersPage";
import UsersPage from "@/pages/UsersPage";
import AuditPage from "@/pages/AuditPage";
import PlatformPage from "@/pages/PlatformPage";
import SettingsPage from "@/pages/SettingsPage";
import SupplyPage from "@/pages/SupplyPage";
import RiskPage from "@/pages/RiskPage";
import PhotosPage from "@/pages/PhotosPage";
import DocumentsPage from "@/pages/DocumentsPage";
import CommissioningPage from "@/pages/CommissioningPage";
import ReportsPage from "@/pages/ReportsPage";
import MorePage from "@/pages/MorePage";

function Gate({ platform }) {
  const { session } = useAuth();
  if (session === undefined) return <Spinner />;
  if (!session) return <Navigate to="/login" replace />;
  const isSuper = session.user.role === "super_admin" && !session.tenant;
  if (platform && !isSuper) return <Navigate to="/" replace />;
  if (!platform && isSuper) return <Navigate to="/platform" replace />;
  return <Outlet />;
}

function LoginGate() {
  const { session } = useAuth();
  if (session === undefined) return <Spinner />;
  if (session) return <Navigate to={session.user.role === "super_admin" && !session.tenant ? "/platform" : "/"} replace />;
  return <LoginPage />;
}

export default function App() {
  return (
    <ThemeProvider>
      <AuthProvider>
        <BrowserRouter>
          <Routes>
            <Route path="/login" element={<LoginGate />} />
            <Route element={<Gate platform />}>
              <Route element={<PlatformShell />}><Route path="/platform" element={<PlatformPage />} /></Route>
            </Route>
            <Route element={<Gate />}>
              <Route element={<AppShell />}>
                <Route path="/" element={<DashboardPage />} />
                <Route path="/vehicles" element={<VehiclesPage />} />
                <Route path="/vehicles/:id" element={<VehicleDetailPage />} />
                <Route path="/issues" element={<IssuesPage />} />
                <Route path="/issues/:id" element={<IssueDetailPage />} />
                <Route path="/services" element={<ServicesPage />} />
                <Route path="/reminders" element={<RemindersPage />} />
                <Route path="/users" element={<UsersPage />} />
                <Route path="/audit" element={<AuditPage />} />
                <Route path="/settings" element={<SettingsPage />} />
                <Route path="/supply" element={<SupplyPage />} />
                <Route path="/risk" element={<RiskPage />} />
                <Route path="/photos" element={<PhotosPage />} />
                <Route path="/documents" element={<DocumentsPage />} />
                <Route path="/commissioning" element={<CommissioningPage />} />
                <Route path="/reports" element={<ReportsPage />} />
                <Route path="/more" element={<MorePage />} />
              </Route>
            </Route>
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
        </BrowserRouter>
        <Toaster position="top-right" richColors closeButton />
      </AuthProvider>
    </ThemeProvider>
  );
}
